import { yup } from '@latitude/form';

import { BLOCKED_PUBLIC_EMAIL_DOMAIN_PREFIXES } from '../../constants';

// This Regex is copied from Zod.
// Unfortunately Yup's email matching isn't very strict.
const EMAIL_REGEX =
  /^(?!\.)(?!.*\.\.)([a-z0-9_'+\-.]*)[a-z0-9_+-]@([a-z0-9][a-z0-9-]*\.)+[a-z]{2,}$/i;

export const COMPLETE_YOUR_PROFILE_FORM_SCHEMA = yup.object().shape({
  mainUserEmail: yup
    .string()
    .required('Email is required')
    .matches(EMAIL_REGEX, 'Invalid email')
    .test(
      'isNonPublic',
      'Must be a business email',
      (email) =>
        !BLOCKED_PUBLIC_EMAIL_DOMAIN_PREFIXES.some((domainPrefix) =>
          email.includes(`@${domainPrefix}`),
        ),
    ),
  mainUserFirstName: yup.string().required('First name is required'),
  mainUserLastName: yup.string().required('Last name is required'),
  mainUserCountry: yup.string().required('Country is required'),
  mainUserCheckbox: yup
    .bool()
    .oneOf([true], 'Please check')
    .required('Please check'),
});

export const ORGANIZATION_DETAILS_FORM_SCHEMA = yup.object().shape({
  organizationName: yup.string().required('Name is required'),
  organizationCountry: yup.string().required('Country is required'),
});
